import axios from 'axios';
import { BASE_URI_DEVELOPMENT_CENTER } from '@/api/CONST.js';

const prefix = BASE_URI_DEVELOPMENT_CENTER;

/**
 * @param {object} data
 * @param {*} data.activityId
 * @param {*} data.questionId
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getActivityQuestionRoutes = ({ activityId, questionId }) => axios.get(`${prefix}/activities/${activityId}/questions/${questionId}/routes`);

/**
 * @param {object} data
 * @param {*} data.activityId
 * @param {*} data.questionId
 * @param {*} data.routes
 * @param {import('axios').AxiosRequestConfig} [config]
 * @returns {Promise<AxiosResponse<any>>}
 */
export const sortActivityQuestionRoutes = ({ activityId, questionId, routes }, config = {}) => axios.post(
    `${prefix}/activities/${activityId}/questions/${questionId}/routes/order`,
    { routes },
    config,
);

/**
 * @param {object} data
 * @param {*} data.activityId
 * @param {*} data.questionId
 * @param {*} data.route
 * @returns {Promise<AxiosResponse<any>>}
 */
export const createActivityQuestionRoute = ({ activityId, questionId, route }) => axios.post(
    `${prefix}/activities/${activityId}/questions/${questionId}/routes`,
    route,
);

/**
 * @param {object} data
 * @param {*} data.activityId
 * @param {*} data.questionId
 * @param {*} data.route
 * @returns {Promise<AxiosResponse<any>>}
 */
export const updateActivityQuestionRoute = ({ activityId, questionId, route }) => axios.put(
    `${prefix}/activities/${activityId}/questions/${questionId}/routes/${route.id}`,
    {
        ...route,
    },
);

/**
 * @param {object} data
 * @param {*} data.activityId
 * @param {*} data.questionId
 * @param {*} data.routeId
 * @returns {Promise<AxiosResponse<any>>}
 */
export const removeActivityQuestionRoute = ({ activityId, questionId, routeId }) => axios.delete(`${prefix}/activities/${activityId}/questions/${questionId}/routes/${routeId}`);
